import axios from "axios";
const API = axios.create({ baseURL: 'https://api.inspiredformen.com/api' });

// we are using withcredential because we are using cookie for authentication in the backend. so if you are not login
// token will not be saved in cookie and you wont be able to perform some operation
// like delete post, update post create post etc. so we need to pass withcredentials in the request
export const fetchPosts = () => API.get('/posts');
export const createPost = (newPost) => API.post('/posts', newPost, { withCredentials: true });
export const updatePost = (id, updatedPost) => API.patch(`/posts/${id}`, updatedPost, { withCredentials: true });
export const deletePost = (id) => API.delete(`/posts/${id}`, { withCredentials: true });

// fecth comments
export const fetchComments = (postId) => API.get(`/comments?postId=${postId}`);
export const createComment = (newComment) => API.post('/comments', newComment);

export const fetchCategory = () => API.get('/category');
export const createCategory = (newPost) => API.post('/category', newPost)


export const signIn = (values) => API.post('/auth/login', values, { withCredentials: true })
export const signUp = (values) => API.post('/auth/register', values)
export const logout = () => API.post('/auth/logout', {}, { withCredentials: true });


